/**
 * Created by Administrator on 2017/11/2.
 */
const GlobalEnum = {
  dateType: {
    months: [ '一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月' ],
    shortMonths: [ '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月' ],
    weekdays: [ '周日', '周一', '周二', '周三', '周四', '周五', '周六' ]
  },
  projectTypes: [
    { value: 0, text: '基坑施工' },
    { value: 1, text: '运营监测' },
    { value: 2, text: '基坑监测' },
    { value: 3, text: '高支模监测' },
    { value: 4, text: '边坡工程' },
    { value: 5, text: '桥梁工程' },
    { value: 6, text: '地质监测' },
    { value: 7, text: '尾矿监测' },
    { value: 8, text: '大坝监测' },
    { value: 9, text: '建筑监测' },
    { value: 99, text: '其他' }
  ],
  workStates: [
    {value: 0, text: '监测中' },
    {value: 1, text: '已结束' },
    {value: 2, text: '已归档' },
  ],
  monitorTypes: [
    { value: 1, text: '水位' },
    { value: 2, text: '内部位移' },
    { value: 3, text: '支撑轴力' },
    { value: 4, text: '锚索' },
    { value: 5, text: '降雨量' },
    { value: 6, text: '裂缝' },
    { value: 7, text: 'GNSS' },
    { value: 8, text: '干滩' },
    { value: 9, text: '浸润线' },
    { value: 10, text: '浊度' },
    { value: 11, text: '渗流量' },
    { value: 12, text: '压力' },
    { value: 13, text: '应力' },
    { value: 14, text: '土壤水分' },
    { value: 15, text: '静力水准' },
    { value: 16, text: '混凝土支撑' },
    { value: 17, text: '压强' },
    { value: 18, text: 'PH' },
    { value: 19, text: '内部沉降' },
    { value: 20, text: '全站仪位移监测' },
    { value: 21, text: '应变' },
    { value: 30, text: '收敛监测' },
    { value: 24, text: '温度' },
    { value: 25, text: '湿度' },
    { value: 26, text: '风速' },
    { value: 27, text: '风向' },
    { value: 28, text: '二氧化碳' },
    { value: 29, text: '氨气' },
    { value: 31, text: '倾斜监测' },
    { value: 32, text: '深层水平位移' },
    { value: 34, text: '气象环境' },
    { value: 38, text: '振动监测' },
    { value: 50, text: '原始数据' },
  ],
  ombTypes: [
    { value: 0, text:'大铁雨量采集器' },
    { value: 1, text:'伟思雨量记录仪' },
    { value: 2, text:'葛南MCU32' }
  ],
  detectorTypes: [
    { value: 1, text: 1 },
    { value: 3, text: 3 }
  ],
  roleList: [
    { value: '1', text: '基本用户(二级用户)' },
    { value: '2', text: '企业管理员(一级用户)' },
    { value: '3', text: '一般用户(三级用户)' }
  ],
  weathers: [
    { value: 0, text: '晴' },
    { value: 1, text: '多云' },
    { value: 2, text: '阴' },
    { value: 6, text: '阵雨' },
    { value: 3, text: '小雨' },
    { value: 4, text: '中雨' },
    { value: 5, text: '大雨' }
  ],
  organizationTypes: [
    { value: 1, text: '监测单位' },
    { value: 4, text: '监管单位' }
  ],
  organizationRoles: [
    { value: 1, text: '基础版' },
    { value: 2, text: '专业版' },
    { value: 4, text: '高级版' }
  ],
  limitOfNumber: [
    { value: 0, text: '关闭' },
    { value: 1, text: '启用' },
  ],
  deviceTypes: [
    // 渗压计、扬压计
    { value: 34, text: '葛南振弦式扬压力计VWP-D' },
    { value: 37, text: '葛南VWE型振弦式土压力计' },
    { value: 38, text: '葛南投入式水位计VWP-0.2G' },
    { value: 140, text: '基康渗压计' },//140-基康BGK-4500AL渗压计
    { value: 150, text: '泰佳振弦式渗压计TJ-04B' },
    { value: 162, text: '工讯MAS-KY振弦式孔隙水压计' },
    { value: 172, text: '金码JMZX-5506HB水压计' },
    { value: 331, text: 'WSQ系列温湿度气压传感器' },

    // 静力水准
    { value: 36, text: '葛南JL-1静力水准仪' },
    { value: 51, text: '葛南CJ-1型液压式沉降仪' },
    { value: 240, text: '岩联静力水准仪' },
    { value: 250, text: '盛迪静力水准仪' },
    { value: 260, text: '厦门忻德TPA压力式静力水准仪' },
    { value: 261, text: '厦门忻德TUH超声波式静力水准仪' },

    // 倾角监测，内部位移
    { value: 39, text: '葛南电压式测斜仪' },
    { value: 50, text: '葛南数字式测斜仪GN-1B' },
    { value: 52, text: '葛南测斜仪GN-1B双轴' },
    { value: 95, text: '大铁倾角仪' },
    { value: 173, text: '金码JMZX-7430ADY测斜仪' },
    { value: 270, text: '北微单轴倾角仪' },
    { value: 271, text: '大铁双轴倾角仪' },
    { value: 310, text: 'Senceive节点' },
    { value: 332, text: '大铁倾角仪 - DT-QJY-90WL' },
    { value: 1401, text: '忻德TAC01倾角仪' },
    { value: 2106, text: '通用双轴固定测斜仪' },

    // 明渠流量计
    { value: 32, text: '葛南量水堰GL-1A' },
    { value: 121, text: '讯嘉明渠流量计' },

    // 雨量计
    { value: 89, text: '徐州伟思分钟雨量记录' },
    { value: 90, text: '徐州伟思翻斗式雨量计' },
    { value: 91, text: '徐州伟思数字式雨量计' },

    // 物位计:统一为“距离传感器(mm)”
    { value: 200, text: '距离传感器' },
    { value: 120, text: '迅嘉水位计XJ-F-12C' },
    { value: 180, text: '科隆水位计' },

    // 裂缝计
    { value: 40, text: '葛南VWD-J型振弦式测缝计' },
    { value: 92, text: '大铁振弦式裂缝计' },  // [ticket:170 废弃]，20221226恢复“大铁裂缝计”用途
    { value: 500, text: '甲虫裂缝计(远程推送)' },
    // { value: 141, text: '基康振弦式表面裂缝计' },
    // { value: 142, text: '基康振弦式裂缝计' },

    // 轴力计
    { value: 35, text: '葛南VWR型振弦式钢筋计' },
    { value: 160, text: '工讯MAS-GJ振弦式钢筋计' },
    { value: 161, text: '工讯MAS-ZL振弦式轴力计' },
    { value: 163, text: '工讯导轮式固定测斜仪' },
    { value: 170, text: '金码JMZX-3830HB轴力计' },
    { value: 171, text: '金码JMZX-428HB钢筋计' },
    { value: 174, text: '金码JMZX-212HB应变计' },
    { value: 400, text: '工云振弦应变计' },

    // 土体沉降
    { value: 33, text: '葛南振弦式土体沉降计VWD' },

    // 阵列式位移计
    { value: 320, text: '华思阵列式测斜仪' },

    // 杂项
    { value: 190, text: '康耐德卷帘门' },
    { value: 330, text: 'THP温湿度气压变送器' },
    { value: 130, text: '诺普泰克PH计' },
    { value: 135, text: '百恒仪表浊度仪' },
    { value: 230, text: '新普惠温度传感器' },
    { value: 231, text: '新普惠湿度传感器' },
    { value: 232, text: '新普惠风速传感器' },
    { value: 233, text: '新普惠风向传感器' },
    { value: 234, text: '新普惠PH值传感器' },
    { value: 235, text: '新普惠CO2传感器' },
    { value: 236, text: '新普惠氨气传感器' },
    { value: 237, text: 'RT2030动态三轴加速度计' },
    // 特例：好像与岩一静力水准搭配
    { value: 1, text: '湘银河传感器' },
  ],
  sctTypes: [
    { value: 1, text: '斯比特' },
    { value: 2, text: '大铁检测' },
    { value: 3, text: '湘银河模块' },
    { value: 4, text: '南京葛南' },
    { value: 5, text: '苏州百恒' },
    { value: 6, text: '深圳地质' },
    { value: 7, text: '康耐德模块' },
    { value: 8, text: '湖南岩一' },
    { value: 9, text: '新普惠自动气象站' },
    { value: 10, text: '葛南GDA1801振弦采集模块' },
    { value: 11, text: '葛南GDA1804振弦采集模块' },
    { value: 12, text: '岩联静力水准仪虚拟MCU' },
    { value: 13, text: '盛迪静力水准仪虚拟MCU' },
    { value: 16, text: '忻德采集器' },
    { value: 17, text: '直连MCU' },
  ],
  pointTypes: [
    { value: 0, text: '控制点' },
    { value: 1, text: '监测点' }
  ]
};
export default GlobalEnum;



// WEBPACK FOOTER //
// ./src/managers/enum/global-enum.js